module.exports = __webpack_public_path__ + "static/media/ph.ad6a97c7.svg";